import shopifyGenericDefaults from '../shopify-generic/config.js';

shopifyGenericDefaults.Widgets.find((w) => w.name === 'Facets').initCollapsed = true;
shopifyGenericDefaults.Widgets.find((w) => w.name === 'Facets').initExpandedFacets = [
  'custom_fitment_year_ranges',
  'custom_fitment_make',
  'custom_fitment_model',
  'custom_fitment_series',
  'custom_fitment_engine',
];

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  pagination:
    window.innerWidth < 540
      ? {
          centralRange: 0,
          edgeRange: 1,
          disableDelimeters: true,
        }
      : {},
  facets: {
    ...shopifyGenericDefaults.facets,
    toggleFacet: [{ fields: ['stock'], term: 'In-stock-Only' }],
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['SearchVehicleWidget', 'SearchBox', 'SearchBoxDialogButton'].includes(w.name),
    ),
    {
      name: 'SearchBox',
      location: {
        selector: '#cm-search-box, predictive-search.\\#predictive-search',
      },
      template: 'SearchBox',
      onDropdownItemsReceived: () =>
        shopifyGenericDefaults.Widgets.find((widget) => widget.name === 'SearchBox').onDropdownItemsReceived,
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        replace: '.\\#header-mobile-toolbar > modal-open',
        class: 'cm-mobile-search-box',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HomePageBrandTiles',
      type: 'FacetTiles',
      location: '#cm-homepage-brands',
      template: 'facetTiles/subtitles',
      view: 'carousel',
      facetField: 'vendor',
    },
    {
      name: 'FacetPanelTiles',
      type: 'FacetPanel',
      location: { insertBefore: '#cm_results, #cm-collection-page' },
      template: 'FacetPanelBrandTiles',
      disableCollapse: true,
      fields: ['vendor'],
      showAllAlways: true,
    },
  ],
};
